/**
 * Pure content-block helpers — no store, no socket, no module state.
 *
 * These lived at the top of `handlers/streamingHandlers.ts` and are called from
 * five places across three handler modules. A leaf home (the shape the rest of
 * `stores/helpers/` already uses) is what lets the tool handlers move into their
 * own registrar without an import cycle back into the file they came from.
 *
 * `streamingHandlers` re-exports both, so every existing import site is
 * unchanged.
 */

import type { ContentBlock, ToolUseBlock } from "@/stores/types";

/** Finalize any open thinking blocks — set durationMs from _startedAt. */
export function finalizeThinkingDurations(content: ContentBlock[]): void {
  for (const block of content) {
    if (block.type === "thinking") {
      const tb = block as { _startedAt?: number; durationMs?: number };
      if (tb._startedAt && !tb.durationMs) {
        tb.durationMs = Date.now() - tb._startedAt;
      }
    }
  }
}

/** Mark all running tools as completed. */
export function completeRunningTools(content: ContentBlock[]): ContentBlock[] {
  return content.map((block) => {
    if (
      block.type === "tool_use" &&
      (block as ToolUseBlock).status === "running"
    ) {
      return {
        ...block,
        status: "completed" as const,
        endTime: new Date(),
      } as ToolUseBlock;
    }
    return block;
  });
}
